// @ts-check

class BeckCard extends HTMLElement {
	#closeButton;

	constructor() {
		super();
	}

	connectedCallback() {
		this.#closeButton = this.querySelector(".js-Card-closeButton");

		if (!this.#closeButton) {
			return;
		}

		this.#addEventListeners();
	}

	#addEventListeners() {
		this.#closeButton.addEventListener(
			"click",
			this.#handleCloseClick.bind(this),
		);
	}

	#handleCloseClick(event) {
		event.preventDefault();
		this.hidden = true;
	}
}

customElements.define("beck-card", BeckCard);
